export default __webpack_public_path__ + "static/media/Apple_Pay_Mark.3d2fa901.svg";